import { Component, OnInit } from '@angular/core';
import {Title } from "@angular/platform-browser";
declare var $: any;

@Component({
  selector: 'app-colorado',
  templateUrl: './colorado.component.html',
  styleUrls: ['./colorado.component.css']
})
export class ColoradoComponent implements OnInit {

  public windowwidth:number;

  
  constructor(
    private titleService: Title,
  ) { }

  ngOnInit(): void {
    this.windowwidth=$(window).width();
    this.topposition();
    this.titleService.setTitle("Colorado - SFI Compliance, Inc");
  }

  //scroll to top of the page automatically
  topposition() { 
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutExpo');

    return false;
}

}
